import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuardService } from '@app/shared/auth/role-guard.service';

import { AuthGuard } from '@shared/auth/auth.guard';

import { LoginComponent } from './account/pages/login/login.component';
import { AuthedComponent } from './authed/pages/authed.component';
import { NoAuthComponent } from './no-auth/pages/no-auth.component';
import { ResetPassComponent } from './account/pages/reset/resetpass.component';
import {
  ScreeningMobileUploadEvidencesComponent,
  UploadImagesMobileComponent,
} from '@app/shared/components';
import { StockEntryMobileUploadComponent } from '../tvf/stock-entry/pages/mobile-upload/stock-entry-mobile-upload.component';
import { IPS_ITEMS } from './models/ips';
import { TVF_ITEMS } from './models/tvf';
import { TVO_ITEMS } from './models/tvo';

export const menuList = {
  ips: IPS_ITEMS,
  tvf: TVF_ITEMS,
  tvo: TVO_ITEMS,
};

const routes: Routes = [
  {
    path: '',
    redirectTo: 'ips',
    pathMatch: 'full',
  },
  {
    path: 'ips',
    component: AuthedComponent,
    data: { menuList: menuList.ips },
    loadChildren: async () => (await import('../ips/ips.module')).IpsModule,
    canActivate: [AuthGuard, RoleGuardService],
  },
  {
    path: 'tvf',
    component: AuthedComponent,
    data: { menuList: menuList.tvf },
    loadChildren: async () => (await import('../tvf/tvf.module')).TvfModule,
    canActivate: [AuthGuard, RoleGuardService],
  },
  {
    path: 'tvo',
    component: AuthedComponent,
    data: { menuList: menuList.tvo },
    loadChildren: async () => (await import('../tvo/tvo.module')).TvoModule,
    canActivate: [AuthGuard, RoleGuardService],
  },
  {
    path: '',
    component: NoAuthComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginComponent,
      },
    ],
  },
  {
    path: 'login/resetar',
    component: ResetPassComponent,
  },
  {
    path: 'upload/files/triagem',
    component: UploadImagesMobileComponent,
  },
  {
    path: 'upload/evidences/screening',
    component: ScreeningMobileUploadEvidencesComponent,
  },
  {
    path: 'upload/recebimento',
    component: StockEntryMobileUploadComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class CoreRoutes {}
